import Layout from "@/views/layout/index";

const data = [
  {
    path: "/waterage",
    name: "waterage",
    target: true,
    component: Layout,
    isChildren: true,
    hidden: true,
    meta: {title: '水路货运', icon: 'el-icon-s-help'},
    children: [
      {
        path: '/waterage',
        meta: {title: '信息大厅', icon: 'el-icon-s-help'},
        component: () => import('@/views/logisticscenter/waterage/index'),
      },
      {
        path: '/waterage/dcfw',
        meta: {title: '订舱服务', icon: 'el-icon-s-help'},
        component: () => import('@/views/logisticscenter/waterage/dcfw'),
      },
      {
        path: '/waterage/zxxd',
        meta: {title: '在线下单', icon: 'el-icon-s-help'},
        component: () => import('@/views/logisticscenter/waterage/zxxd'),
      },
      {
        path: '/waterage/wlgz',
        meta: {title: '物流跟踪', icon: 'el-icon-s-help'},
        component: () => import('@/views/logisticscenter/waterage/wlgz'),
      }
    ]
  }
]


export default data



// WEBPACK FOOTER //
// ./src/router/waterage.js